import { Component } from '@angular/core';
import { WizardPageComponent } from '../../../wizard/wizard-page-component';
import type { UpgradeLicenseWizard } from '../upgrade-license-wizard';

@Component({
  standalone: false,
  selector: 'mtn-upgrade-license-page',
  templateUrl: './upgrade-license-page.component.html',
  styleUrls: ['./upgrade-license-page.component.scss']
})
export class UpgradeLicensePageComponent extends WizardPageComponent<UpgradeLicenseWizard> {

  key = 'upgrade-license';

  constructor() {
    super();
    this.title = 'Contact Retailstat to Upgrade';
    this.closeButtonText = 'Close';
  }

}
